import { APP_INITIALIZER, Type } from '@angular/core';
import { InitializationService } from '@core/data-access/models/service.model';
import { map } from 'lodash';

export const provideAppInitializationServices = (initializationServices: Type<unknown & InitializationService>[]) =>
  map(initializationServices, (initializationService: InitializationService) => ({
    provide: APP_INITIALIZER,
    useFactory: (initializationService: InitializationService) => () => initializationService.init(),
    deps: [initializationService],
    multi: true
  }));
